import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Modalite, ModalitesService } from 'src/app/core/modalites.service';
import { AlertesService } from 'src/app/shared/alertes.service';
import { FormulaireService } from '../../formulaire.service';
import { ModeRenduService } from '../../mode-rendu/mode-rendu.service';
import { SaisieService } from '../../saisie.service';

@Component({
  selector: 'bis-bav',
  templateUrl: './bav.component.html',
  styleUrls: ['./bav.component.css']
})
export class BavComponent implements OnInit, OnDestroy {
  @Input()
  erreursMap: Map<string, string>;

  public rootForm: UntypedFormGroup;
  private subBav : Subscription;
  private subDetailBav : Subscription;
  public nbBav: number = 0;
  private modalites: Modalite[] = [];
  private subscriptions: Subscription[] = [];
  step: number = 0;

  public infobulle1: string = 'Assignation à résidence sous surveillance électronique';

  public infobulleTotaux: string = 'Le bouton "Calcul Totaux" constitue un outil d\'aide à la saisie. \
  Attention à ne pas l\'utiliser si vous saisissez directement un total sans saisir toutes les valeurs détails,\
  sinon le total que vous avez saisi sera écrasé par le recalcul déclenché par le clic sur le bouton de calcul...';

  constructor(
    private formulaireService: FormulaireService,
    public alertesService: AlertesService,
    public modeRendu: ModeRenduService,
    public modaliteService: ModalitesService,
    public saisieService: SaisieService
  ) {
    this.rootForm = this.formulaireService.getRootForm();
    if (! this.listeBav) {
      (this.rootForm.get('dg') as UntypedFormGroup).setControl('listeBav', new UntypedFormArray([]));
    } 
    if (! this.detailBavs) {
      (this.rootForm.get('bav') as UntypedFormGroup).setControl('detailBavs', new UntypedFormArray([]));
    }
   }

  ngOnInit(): void {
    // on récupère la nomenclature ielst pour trouver le libelle BAV car on a que ielst 
    this.subscriptions.push(
      this.modaliteService.getModalites('ielstBav').subscribe(modalites => {
        this.modalites = modalites;
      })
    );
    setTimeout(() => {
        // On initie la boucle detailBavs avec celle de listeBav
        this.subBav = this.listeBav.valueChanges.pipe(distinctUntilChanged(),debounceTime(100)).subscribe(valeur => {
            if (valeur instanceof Array) {
              valeur.forEach((listeBav, index) => {
                this.detailBavs.controls[index].get('bavRang').setValue(listeBav.xxBavRang);
                this.detailBavs.controls[index].get('bavIelst').setValue(listeBav.xxBavIelst);
              })
            }
            this.nbBav = this.formulaireService.getRootForm().get('dg').get('xxBavNb').value;
        });
        this.listeBav.updateValueAndValidity();

        // Mises à jours de la synthèse si une zone bouge sur les bavs
        this.subDetailBav = this.detailBavs.valueChanges.pipe(distinctUntilChanged(),debounceTime(100)).subscribe(valeur => {
          this.saisieService.majsSynthese(this.formulaireService.getRootForm().get('syntheseBav'), this.detailBavs);
        });
        this.detailBavs.updateValueAndValidity();

        // Gestion des controles bloquants en rechargement questionnaire
        for (let index = 0; index < this.detailBavs.length; index++) {
          this.saisieService.ajoutValidateurCroiseBAV(this.detailBavs, index);
          this.detailBavs.controls[index].updateValueAndValidity();
        }
    }, 1000);
   
  }

  ngOnDestroy(): void {
    if (this.subBav) {
      this.subBav.unsubscribe();
    }
    if (this.subDetailBav) {
      this.subDetailBav.unsubscribe();
    }
    this.subscriptions.forEach(sub => { sub.unsubscribe(); });
  }

  /** Permet de renseigner libelleJuridiction en fonction de l’identifiantJuridiction passé en paramètre */
  public gestionLibelle(identifiantJuridiction: string): string {
    return this.saisieService.gestionLibelle(identifiantJuridiction, this.modalites);
  }

  public get formulaire(): UntypedFormGroup {
    return this.formulaireService.getRootForm().get('bav') as UntypedFormGroup;
  }

  get listeBav() {
    return this.formulaireService.getRootForm().get('dg').get('listeBav') as UntypedFormArray;
  }

  get detailBavs() {
    return this.rootForm.get('bav').get('detailBavs') as UntypedFormArray;
  }

  public setStep(index: number): void {
    this.step = index;
  }
   
  public calculTotalTableauBavF11(rang: number): void {
        //Calcul Total bavAaNbTot 
        this.saisieService.calculTotalBoucle8(this.detailBavs, rang, 'bavAaNbTot', 'bavAaNbAav', 'bavAaNbJur', 'bavAaNbPsy', 'bavAaNbWsoc', 'bavAaNbAutrInterv', 'bavAaNbDir', 'bavAaNbComptsecr', 'bavAaNbAutrSupport', false);

        //Calcul Total bavAaEtpTot 
        this.saisieService.calculTotalBoucle8(this.detailBavs, rang, 'bavAaEtpTot', 'bavAaEtpAav', 'bavAaEtpJur', 'bavAaEtpPsy', 'bavAaEtpWsoc', 'bavAaEtpAutrInterv', 'bavAaEtpDir', 'bavAaEtpComptsecr', 'bavAaEtpAutrSupport', true);
  }

  public calculTotalTableauBavF21(rang: number): void {
        //Calcul Total bavBbPremContactOrigTot
        this.saisieService.calculTotalBoucle2(this.detailBavs, rang, 'bavBbPremContactOrigTot', 'bavBbPremContactOrigAsso', 'bavBbPremContactOrigPerso');
  }

  public calculTotalTableauBavF22(rang: number): void {
        //Calcul Total bavBbPremContactModeTot
        this.saisieService.calculTotalBoucle3(this.detailBavs, rang, 'bavBbPremContactModeTot', 'bavBbPremContactModeEcrit', 'bavBbPremContactModeTel', 'bavBbPremContactModePres');
  }

  public calculTotalTableauBavF31(rang: number): void {
        //Calcul Total bavCcRecuNbTot
        this.saisieService.calculTotalBoucle2(this.detailBavs, rang, 'bavCcRecuNbTot', 'bavCcRecuVictNb', 'bavCcRecuNvictNb');

        //Calcul Total bavCcRecuSuiviTot
        this.saisieService.calculTotalBoucle2(this.detailBavs, rang, 'bavCcRecuSuiviTot', 'bavCcRecuVictSuivi', 'bavCcRecuNvictSuivi');

        //Calcul Total bavCcRecuEntretTot
        this.saisieService.calculTotalBoucle2(this.detailBavs, rang, 'bavCcRecuEntretTot', 'bavCcRecuVictEntret', 'bavCcRecuNvictEntret');
  }

  public calculTotalTableauBavF41(rang: number): void {
        //Calcul Total bavDdFaitTot
        this.saisieService.calculTotalBoucle4(this.detailBavs, rang, 'bavDdFaitTot', 'bavDdFaitPersoTot', 'bavDdFaitBienTot', 'bavDdFaitCircuTot', 'bavDdFaitAutr');
  }

  public calculTotalTableauBavF42(rang: number): void {
        //Calcul Total bavDdFaitPersoTot
        this.saisieService.calculTotalBoucle10(this.detailBavs, rang, 'bavDdFaitPersoTot', 'bavDdFaitPersoHomiVolo', 'bavDdFaitPersoSexuel', 'bavDdFaitPersoProxe', 'bavDdFaitPersoViolen', 'bavDdFaitPersoHomiInvolo', 'bavDdFaitPersoBless', 'bavDdFaitPersoAband', 'bavDdFaitPersoMenace','bavDdFaitPersoDiscri', 'bavDdFaitPersoAutr');
  }

  public calculTotalTableauBavF43(rang: number): void {
        //Calcul Total bavDdFaitBienTot
        this.saisieService.calculTotalBoucle5(this.detailBavs, rang, 'bavDdFaitBienTot', 'bavDdFaitBienVolSimp', 'bavDdFaitBienVolAggr', 'bavDdFaitBienEscro', 'bavDdFaitBienDegrad', 'bavDdFaitBienAutr');
  }

  public calculTotalTableauBavF44(rang: number): void {
        //Calcul Total bavDdFaitCircuTot
        this.saisieService.calculTotalBoucle2(this.detailBavs, rang, 'bavDdFaitCircuTot', 'bavDdFaitCircuBless', 'bavDdFaitCircuDegat');
  }

  public calculTotalTableauBavF51(rang: number): void {
        //Calcul Total bavEeEntretTot
        this.saisieService.calculTotalBoucle5(this.detailBavs, rang, 'bavEeEntretTot', 'bavEeEntretPsy', 'bavEeEntretJur', 'bavEeEntretSoc', 'bavEeEntretEcout', 'bavEeEntretAutr');
  }

  public calculTotalTableauBavF52(rang: number): void {
        //Calcul Total bavEeDiliTot
        this.saisieService.calculTotalBoucle19(this.detailBavs, rang, 'bavEeDiliTot', 'bavEeDiliJur', 'bavEeDiliCivi', 'bavEeDiliFondGaran', 'bavEeDiliSarvi', 'bavEeDiliPenit', 'bavEeDiliPolgend', 'bavEeDiliAvoc', 'bavEeDiliHuis','bavEeDiliOrgaSoc', 'bavEeDiliColter', 'bavEeDiliPref', 'bavEeDiliOrgaLogt', 'bavEeDiliHebgt', 'bavEeDiliHosto', 'bavEeDiliAsso', 'bavEeDiliAssur', 'bavEeDiliSad', 'bavEeDiliFrserv', 'bavEeDiliAutr');
  }

  public calculTotalTableauBavF54a2(rang: number): void {
        //Calcul Total bavEeProcPostSentenTot
        this.saisieService.calculTotalBoucle4(this.detailBavs, rang, 'bavEeProcPostSentenTot', 'bavEeProcPostSentenDec', 'bavEeProcPostSentenDef', 'bavEeProcPostSentenRecour', 'bavEeProcPostSentenAutr');
  }

  public calculTotalTableauBavF54a1(rang: number): void {
        //Calcul Total bavEeProcPreSentenTot
        this.saisieService.calculTotalBoucle6(this.detailBavs, rang, 'bavEeProcPreSentenTot', 'bavEeProcPreSentenPlainte', 'bavEeProcPreSentenEnq', 'bavEeProcPreSentenCss', 'bavEeProcPreSentenPc', 'bavEeProcPreSentenAud', 'bavEeProcPreSentenAutr');
  }
  
  public calculTotalTableauBavF54b1(rang: number): void {
        //Calcul Total bavEeAuteurPreSentenTot
        this.saisieService.calculTotalBoucle5(this.detailBavs, rang, 'bavEeAuteurPreSentenTot', 'bavEeAuteurPreSentenCj', 'bavEeAuteurPreSentenDp', 'bavEeAuteurPreSentenFinDeten', 'bavEeAuteurPreSentenFinMes', 'bavEeAuteurPreSentenAutr');
  }
  
  public calculTotalTableauBavF54b2(rang: number): void {
        //Calcul Total bavEeAuteurPostSentenTot
        this.saisieService.calculTotalBoucle5(this.detailBavs, rang, 'bavEeAuteurPostSentenTot', 'bavEeAuteurPostSentenMilFer', 'bavEeAuteurPostSentenMilOuv', 'bavEeAuteurPostSentenFinDeten', 'bavEeAuteurPostSentenFinMes', 'bavEeAuteurPostSentenAutr');
  }
  
  public calculTotalTableauBavF54c1(rang: number): void {
        //Calcul Total bavEeDiPreSentenTot
        this.saisieService.calculTotalBoucle2(this.detailBavs, rang, 'bavEeDiPreSentenTot', 'bavEeDiPreSentenCivi', 'bavEeDiPreSentenAutr');
  }
  
  public calculTotalTableauBavF54c2(rang: number): void {
        //Calcul Total bavEeDiPostSentenTot
        this.saisieService.calculTotalBoucle6(this.detailBavs, rang, 'bavEeDiPostSentenTot', 'bavEeDiPostSentenCivi', 'bavEeDiPostSentenSarvi', 'bavEeDiPostSentenHuis', 'bavEeDiPostSentenJapSpip', 'bavEeDiPostSentenFondGar', 'bavEeDiPostSentenAutr');
  }
  
  public calculTotalTableauBavF55(rang: number): void {
        //Calcul Total bavEeDemarTot
        this.saisieService.calculTotalBoucle6(this.detailBavs, rang, 'bavEeDemarTot', 'bavEeDemarPlainte', 'bavEeDemarAj', 'bavEeDemarAud', 'bavEeDemarAccomp', 'bavEeDemarDi', 'bavEeDemarAutr');
  }

}